import styled from 'styled-components';

import { colors, fonts, fontSizes } from 'shared/defaultTheme';
import { Modal } from 'shared/components/modal/Modals';
import { Button } from 'shared/components/Buttons';

export const ChatWrapper = styled.div`
  .chat-box-container {
    box-sizing: border-box;
    height: 500px;
    overflow: auto;
    width: 100%;
    border: 1px solid ${colors.pattens};
    border-radius: 8px;
    padding: 15px;
    display: grid;
    grid-template-rows: ${({ maxAnswerLength }) => `repeat(${maxAnswerLength}, max-content)`};
    .chat-circle {
      height: 31px;
      width: 31px;
      background-color: ${({ mainColor }) => mainColor};
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      .chat-circle-text {
        color: ${colors.white};
        font-family: ${fonts.default};
        font-size: 18px;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 21px;
        padding-top: 4px;
      }
    }
    .chat-circle-color-main {
      background-color: ${colors.darkCharcoal};
    }
    .chat-info-main {
      width: 99%;
      .chat-date-main {
        width: 100%;
      }
    }

    .chat-comment-box {
      height: auto;
      border-radius: 8px;
      padding: 15px;
    }

    .chat-color-box-secondary {
      background-color: ${colors.whiteSmoke};
      width: auto;
    }

    .chat-color-box-main {
      background-color: ${colors.pattens};
      width: auto;
    }
    .attachment-box-container {
      .attachment-box {
        display: grid;
        grid-template-columns: repeat(3, max-content);
        width: 100%;
        .chat-attachment-box-component {
          cursor: pointer;
          &:focus,
          &:active {
            background-color: ${colors.suvaGrey};
          }
        }
        .upload-img-container {
          height: 160px;
          width: 200px;
          cursor: pointer;
          .chat-upload-img {
            background-size: cover;
          }
        }
      }
    }
  }
  .chat-upload-document-container {
    width: 166px;
    padding-top: 13px;
  }
`;

export const ButtonPreview = styled(Button)`
  width: 120px;
  height: 26px;
  background-color: ${colors.suvaGrey};
  margin-left: 10px;
  span {
    font-size: ${fontSizes.xs}px;
    position: relative;
    top: 1px;
  }
  svg {
    fill: ${colors.white};
  }
  &:focus,
  &:hover {
    border: 1px solid ${colors.spanishGray};
    border-radius: 2px;
    color: ${colors.suvaGrey};
    background-color: #fff;
    span {
      color: ${colors.suvaGrey};
    }
    svg {
      fill: ${colors.suvaGrey};
    }
  }
`;

export const ButtonUpload = styled(Button)`
  width: 166px;
  height: 26px;
  background-color: ${colors.suvaGrey};
  margin-left: 10px;
  span {
    font-size: ${fontSizes.xs}px;
    position: relative;
    top: 1px;
  }
  svg {
    fill: ${colors.white};
  }
  &:focus,
  &:hover {
    border: 1px solid ${colors.spanishGray};
    border-radius: 2px;
    color: ${colors.suvaGrey};
    background-color: #fff;
    span {
      color: ${colors.suvaGrey};
    }
    svg {
      fill: ${colors.suvaGrey};
    }
  }
`;

export const AttachFormModal = styled(Modal)`
  top: 4%;
  .modal-content {
    border-radius: 4px;
  }
  .modal-header {
    border: 0;
    height: 36px;
    padding-top: 20px;
    padding-bottom: 0;

    svg {
      fill: ${colors.suvaGrey} !important;
      height: 18px !important;
      width: 18px !important;
    }
  }
  .img-viewer-container {
    height: 500px;
    .img-viewer {
      background-size: 100% 100%;
    }
  }
`;
